import React from 'react';
import { FaGithub, FaLinkedin, FaDownload } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import './Sidebar.css';

interface SidebarProps {
  profileImage?: string;
  name?: string;
  title?: string;
  education?: string;
  bio?: React.ReactNode;
  currentProject?: {
    label: string;
    title: string;
    description: string;
    tags: string[];
  };
  links?: {
    github?: string;
    linkedin?: string;
    email?: string;
    resume?: string;
  };
}

const Sidebar: React.FC<SidebarProps> = ({
  profileImage,
  name = 'Your Name',
  title = 'Your Title',
  education = 'Your Education',
  bio,
  currentProject,
  links = {}
}) => {
  return (
    <aside className="sidebar">
      <div className="sidebar-content">
        <div className="profile-info">
          {profileImage && <img src={profileImage} alt={name} className="profile-image" />}
          <div>
            <h1 className="profile-name">{name}</h1>
            <div className="profile-meta">
              <p className="profile-sub">{education}</p>
              <p className="profile-sub">{title}</p>
            </div>
          </div>
        </div>

        {bio && <div className="profile-bio">{bio}</div>}

        {currentProject && (
          <div className="current-project">
            <p className="current-project-label">{currentProject.label}</p>
            <h3 className="current-project-title">{currentProject.title}</h3>
            <p className="current-project-description">{currentProject.description}</p>
            <div className="current-project-tags">
              {currentProject.tags.map((tag) => (
                <span key={tag} className="tag">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        )}

        <div className="social-links">
          {links.github && (
            <a
              href={links.github}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link">
              <FaGithub />
              <span>GitHub</span>
            </a>
          )}
          {links.linkedin && (
            <a
              href={links.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link">
              <FaLinkedin />
              <span>LinkedIn</span>
            </a>
          )}
          {links.email && (
            <a href={`mailto:${links.email}`} className="social-link">
              <MdEmail />
              <span>Email</span>
            </a>
          )}
          {links.resume && (
            <a
              href={links.resume}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link">
              <FaDownload />
              <span>Resume</span>
            </a>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
